import React, { useContext } from "react";
import DataContext from "../../Context";
import LocalizationContext from "../../Localization/LanguageContext";
import { ILocalizationContext } from "../../Localization/Models/ILocalizationContext";
import { IPolicy } from "../../Models/PolicyInfo";
import "./ProgressIndicator.css";
import StatusBubble from "./StatusBubble";
import StatusLine from "./StatusLine";

const ProgressIndicator = () => {
  const { progressState } = useContext(DataContext) as IPolicy;
  const { getValue } = useContext(LocalizationContext) as ILocalizationContext;
  const pageDescriptions = [
    getValue('ProgressIndicator', 'Step1'),
    getValue('ProgressIndicator', 'Step2'),
    getValue('ProgressIndicator', 'Step3'),
    getValue('ProgressIndicator', 'Step4'),
  ];

  return (
    <div>
      <div className="progress-container">
        <div
          className="bubble-container"
          // added style alongside CSS, because this component is dynamic and requires specific grid configs
          style={{
            gridTemplateColumns: `repeat(${pageDescriptions.length}, 1fr)`,
            width: `${pageDescriptions.length * 10}rem`,
          }}
        >
          {/* loop n times to create n bubbles */}
          {pageDescriptions.map((desc, idx) => (
            <StatusBubble
              key={idx + 1}
              state={progressState}
              bubbleNum={idx + 1}
              displayNum={true}
              description={desc}
              activeState={true}
              previousState={idx === pageDescriptions.length - 1 ? false : true}
              inactiveState={idx === 0 ? false : true}
            />
          ))}
        </div>

        <div
          className="line-container"
          // added style alongside CSS because this component is dynamic and requires specific grid configs
          style={{
            gridTemplateColumns: `repeat(${pageDescriptions.length - 1}, 1fr)`,
            width: `${(pageDescriptions.length - 1) * 10}rem`,
          }}
        >
          {/* loop n-1 times to create the lines between n bubbles */}
          {pageDescriptions.map((desc, idx) => {
            if (idx < pageDescriptions.length - 1)
              return <StatusLine key={idx + 1} state={progressState} lineNum={idx + 1} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default ProgressIndicator;
